import * as _ from 'lodash'
import {ProductBO} from "./ProductBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {
    WB_FinishedProductRelationshipRow
} from "../PA.Core/PAdbSchemaRows";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {Product_Type_Open_Stock} from "../PA.MD.Core/MD.Constants";


export class ProductBOValidations {


    static ValidateEmptyFields(aBO: ProductBO): Promise<void> {


        return new Promise<void>((resolve, error) => {

            // Validate Product Name
            if (_.isEmpty(aBO.WB_Product.cif.PRODUCT_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyName',
                        type: MessageType.Error,
                        title: "Product Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyName')
            }

            // Warn (non-blocking) when an Open Stock Finished Product has no Case Pack
            if (aBO.WB_Product.cif.WB_PROD_TYPE_ID === Product_Type_Open_Stock
                && !aBO.WB_Product.cif.CASE_PACK_SIZE) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'OpenStockCasePackMissing',
                        type: MessageType.Warning,
                        title: "Case Pack should be set for Open Stock Finished Products",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('OpenStockCasePackMissing')
            }

            let bNameIncorrect = false
            let bEmptyStartDate = false
            let bEmptyEndDate = false
            let bDateOrderingIncorrect = false
            let bHierarchyIncorrect = false

            _.forEach(_.filter(aBO.WB_Product.WB_FinishedProductRelationshipRows, (x: WB_FinishedProductRelationshipRow) => x.isActive), (aRow) => {

                if (_.isEmpty(aRow.WB_ProductGroupRow.cif.PRODUCT_GROUP_NAME)) {
                    bNameIncorrect = true
                }

                if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                    bEmptyStartDate = true
                }

                if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                    bEmptyEndDate = true
                }

                if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                    if (aRow.EffectiveEndDt < aRow.EffectiveStartDt) {
                        bDateOrderingIncorrect = true
                    }
                }

                if (!aRow.cif.WB_PRDH_ID) {
                    bHierarchyIncorrect = true
                }
            })

            if (bNameIncorrect) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ProductGrpNameIncorrect',
                        type: MessageType.Error,
                        title: "Product Groups Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ProductGrpNameIncorrect')

            }

            if (bDateOrderingIncorrect) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ProductGrpDateOrderingIncorrect',
                        type: MessageType.Error,
                        title: "Effective start date must be before the effective end date",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ProductGrpDateOrderingIncorrect')

            }

            if (bEmptyStartDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ProductGrpEmptyStartDate',
                        type: MessageType.Error,
                        title: "Effective Start Date cannot be empty in Product Groups",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ProductGrpEmptyStartDate')
            }

            if (bEmptyEndDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ProductGrpEmptyEndDate',
                        type: MessageType.Error,
                        title: "Effective End Date cannot be empty in Product Groups",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ProductGrpEmptyEndDate')
            }

            if (bHierarchyIncorrect) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ProductGrpHierarchyIDIncorrect',
                        type: MessageType.Error,
                        title: "Hierarchy ID should not be null in Product Groups",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ProductGrpHierarchyIDIncorrect')

            }


            resolve()

        })

    }
}
